<div class="login-landingpage-container">
  @if(this.settingService.logoReady && this.settingService.iconReady && this.settingService.altlogoReady && this.settingService.alticonReady) {

  
    <div class="centered-panel" [class.shifted]="logoShifted">
      <div class="TitleImgContainer">
        @if (icon) {
          <img class="TitleImg" [src]="icon">
        }
      </div>
    </div>


    <div class="login-container" [class.shifted]="logoShifted">
      <div class="inner-wrapper">
        <div class="login-Title-Container">
          <div class="login-title-text-container">
            @if(windowCredential == 'signin') {
              <h1 class="login-title-text">Login to an account</h1>
            }
            @if(windowCredential == 'signup') {
              <h1 class="login-title-text">Create an account</h1>
            }
            @if(windowCredential == 'forgotpass') {
              <h1 class="login-title-text">Create an account</h1>
            }
            
          </div>
          <div class="login-title-description">
            join and have all sorts of benefits in becoming a homers member. earn points and enjoy small activities to earn free products!
          </div>
        </div>



        @if(windowCredential == 'signin'){
          <form (ngSubmit)="loginformSubmitted()" novalidate [formGroup]="loginForm" style="overflow: auto;">
            <ion-list class="disable-background-color">
              <ion-item class="disable-background-color">
                <ion-icon name="at-circle-outline"></ion-icon>
                <ion-label floating>
                  @if (formErrors.has('email')) {
                    <span color="danger"><br />{{formErrors.get('email')}}</span>
                  }
                </ion-label>
                <ion-input formControlName="email" type="email" [placeholder]="emailPlaceHolder"></ion-input>
              </ion-item>

              <ion-item class="disable-background-color">
                <ion-icon name="lock-closed-outline"></ion-icon>
                <ion-label floating>
                  @if (formErrors.has('password')) {
                    <span color="danger"><br />{{formErrors.get('password')}}</span>
                  }
                </ion-label>
                <ion-input formControlName="password" type="password" [placeholder]="passwordPlaceHolder"></ion-input>
              </ion-item>

              
              <div class="loginOption">
                <div class="Option" (click)="changeAuth('signup')">
                  sign up
                </div>

                <div class="OptionSeperator">
                  /
                </div>

                <div class="Option" (click)="changeAuth('forgotpass')">
                  forgot password
                </div>
              </div>

            </ion-list>


            <div padding style="padding-left: 18px;">
              <ion-button type="submit" [disabled]="!loginForm.valid" ion-button color="primary" expand="block">
                {{ 'Auth.Login' | translate }}
              </ion-button>
            </div>
          </form>
        }

        @if(windowCredential == 'signup' && registrationStep == 1){
          <form (ngSubmit)="registrationformSubmitted()" novalidate [formGroup]="registerForm" style="overflow: auto;">
            <ion-list class="disable-background-color">
              <ion-item class="disable-background-color">
                <ion-icon name="at-circle-outline"></ion-icon>
                <ion-label floating>
                  @if (formErrors.has('email')) {
                    <span color="danger"><br />{{formErrors.get('email')}}</span>
                  }
                </ion-label>
                <ion-input formControlName="email" type="email" [placeholder]="emailPlaceHolder"></ion-input>
              </ion-item>

              <!--
              <ion-item class="disable-background-color">
                <ion-icon name="lock-closed-outline"></ion-icon>
                <ion-label floating>
                  @if (formErrors.has('password')) {
                    <span color="danger"><br />{{formErrors.get('password')}}</span>
                  }
                </ion-label>
                <ion-input formControlName="password" type="password" [placeholder]="passwordPlaceHolder"></ion-input>
              </ion-item>
              -->

              
              <div class="loginOption">
                <div class="Option" (click)="changeAuth('signin')">
                  sign in
                </div>
              </div>

            </ion-list>


            <div padding style="padding-left: 18px;">
              <ion-button type="submit" [disabled]="!registerForm.valid" ion-button color="primary" expand="block">
                {{ 'General.Next' | translate }}
              </ion-button>
            </div>
          </form>
        }

        @if(windowCredential == 'signup' && registrationStep == 2){
          <form (ngSubmit)="registrationConfirmationformSubmitted()" novalidate [formGroup]="registerConfirmationForm" style="overflow: auto;">
            <ion-list class="disable-background-color">
              <!--
              @if (emailCode.memberCard != null) {
                <ion-item>
                  <ion-label position="floating">
                    {{ 'EmailVerification.MemberCardNumber'| translate }}
                  </ion-label>
                  <ion-input type="text" [value]="emailCode.memberCard" disabled></ion-input>
                </ion-item>
              }
              -->

              <ion-item class="disable-background-color">
                <ion-label position="floating">
                  {{ 'EmailVerification.VerificationCode' | translate }}
                  @if (formErrors.has('randomCode')) {
                    <ion-text
                    color="danger"><br />{{formErrors.get('randomCode')}}</ion-text>
                  }
                </ion-label>
                <ion-input formControlName="randomCode" type="text"></ion-input>
              </ion-item>

              
              <ion-item class="disable-background-color">
                <ion-label position="floating">
                  {{ 'Auth.FirstName' | translate }}
                  @if (formErrors.has('firstName')) {
                    <ion-text
                    color="danger"><br />{{formErrors.get('firstName')}}</ion-text>
                  }
                </ion-label>
                <ion-input formControlName="firstName" type="text"></ion-input>
              </ion-item>

              <ion-item class="disable-background-color">
                <ion-label position="floating">
                  {{ 'Auth.LastName' | translate }}
                  @if (formErrors.has('lastName')) {
                    <ion-text
                    color="danger"><br />{{formErrors.get('lastName')}}</ion-text>
                  }
                </ion-label>
                <ion-input formControlName="lastName" type="text"></ion-input>
              </ion-item>

              <ion-item class="disable-background-color">
                <ion-label position="floating">
                  {{ 'Auth.Password' | translate }}
                  @if (formErrors.has('password')) {
                    <ion-text
                    color="danger"><br />{{formErrors.get('password')}}</ion-text>
                  }
                </ion-label>
                <ion-input formControlName="password" type="password"></ion-input>
              </ion-item>

              <ion-item class="disable-background-color">
                <ion-label position="floating">
                  {{ 'Auth.ConfirmPassword' | translate }}
                  @if (formErrors.has('confirmPassword')) {
                    <ion-text
                    color="danger"><br />{{formErrors.get('confirmPassword')}}</ion-text>
                  }
                </ion-label>
                <ion-input formControlName="confirmPassword" type="password"></ion-input>
              </ion-item>

              <div class="loginOption">
                <div class="Option" (click)="changeAuth('signin')">
                  sign in
                </div>
              </div>

            </ion-list>


            <div padding style="padding-left: 18px;">
              <ion-button type="submit" [disabled]="!registerConfirmationForm.valid" ion-button color="primary" expand="block">
                {{ 'Auth.Register' | translate }}
              </ion-button>
            </div>
          </form>
        }

        @if(windowCredential == 'forgotpass' && !emailCode){
          <form (ngSubmit)="forgotPassformSubmitted()" novalidate [formGroup]="forgotPassForm" style="overflow: auto;">
            <ion-list class="disable-background-color">

              <ion-item class="disable-background-color">
                <ion-label position="floating">
                  @if (formErrors.has('email')) {
                    <span color="danger"><br />{{formErrors.get('email')}}</span>
                  }
                </ion-label>
                <ion-input formControlName="email" type="email" [placeholder]="emailPlaceHolder"></ion-input>
              </ion-item>


              <div class="loginOption">
                <div class="Option" (click)="changeAuth('signin')">
                  sign in
                </div>
                <div class="OptionSeperator">
                  /
                </div>
                <div class="Option" (click)="changeAuth('signup')">
                  sign up
                </div>
              </div>

            </ion-list>


            <div padding style="padding-left: 18px;">
              <ion-button type="submit" [disabled]="!forgotPassForm.valid" ion-button color="primary" expand="block">
                {{ 'Auth.SendVerificationCode' | translate }}
              </ion-button>
            </div>
          </form>
        }

        @if(windowCredential == 'forgotpass' && emailCode){
          <form (ngSubmit)="onPassChangeformSubmitted()" novalidate [formGroup]="passChangeForm" style="overflow: auto;">
            <ion-list class="disable-background-color">

              <ion-item class="disable-background-color">
                <ion-label position="floating">
                  @if (formErrors.has('verificationCode')) {
                    <span color="danger"><br />{{formErrors.get('verificationCode')}}</span>
                  }
                </ion-label>
                <ion-input formControlName="verificationCode" type="text" [placeholder]="verificationCodePlaceHolder"></ion-input>
              </ion-item>

              <ion-item class="disable-background-color">
                <ion-label position="floating">
                  @if (formErrors.has('password')) {
                    <span color="danger"><br />{{formErrors.get('password')}}</span>
                  }
                </ion-label>
                <ion-input formControlName="password" type="password" [placeholder]="passwordPlaceHolder"></ion-input>
              </ion-item>

              <ion-item class="disable-background-color">
                <ion-label position="floating">
                  @if (formErrors.has('confirmPassword')) {
                    <span color="danger"><br />{{formErrors.get('confirmPassword')}}</span>
                  }
                </ion-label>
                <ion-input formControlName="confirmPassword" type="password" [placeholder]="confirmPasswordPlaceHolder"></ion-input>
              </ion-item>

              <p class="text-center">{{ 'Auth.EmailSent' | translate: { email: this.forgotPassForm.get("email").value } }}</p>
              <p class="text-center"><a class="notice-text" (click)="notReceivedAnyCode()">{{ 'EmailVerification.NotReceivedMessage' | translate }}</a></p>

              <div class="loginOption">
                <div class="Option" (click)="changeAuth('signin')">
                  sign in
                </div>
                <div class="OptionSeperator">
                  /
                </div>
                <div class="Option" (click)="changeAuth('signup')">
                  sign up
                </div>
              </div>

            </ion-list>


            <div padding style="padding-left: 18px;">
              <ion-button type="submit" [disabled]="!passChangeForm.valid" ion-button color="primary" expand="block">
                {{ 'Auth.UpdatePassword' | translate }}
              </ion-button>
            </div>
          </form>
        }

        
      </div>
      
    </div>
  }
</div>
